(function proteinCalculatorFactory() {
  "use strict";

  var engine = window.SuplementariaProteinEngine;
  if (!engine) return;

  var STOP_COPY = {
    professional: {
      eyebrow: "Use sua orientação individual",
      title: "A calculadora não deve concorrer com seu plano",
      body: "Como você já recebeu uma meta ou restrição de proteína, use essa orientação. Uma estimativa geral não conhece seus exames, tratamento ou histórico.",
      returnStep: 1,
    },
    scope: {
      eyebrow: "Fora do escopo desta versão beta",
      title: "Esta versão não apresentará uma estimativa",
      body: "Seu perfil ainda não está coberto pela metodologia desta versão. Isso não significa que proteína seja contraindicada.",
      returnStep: 1,
    },
    underage: {
      eyebrow: "Fora do escopo desta versão beta",
      title: "Esta ferramenta foi desenvolvida para adultos",
      body: "Crianças e adolescentes têm necessidades relacionadas ao crescimento e devem receber orientação adequada à idade.",
      returnStep: 1,
    },
    olderAdult: {
      eyebrow: "Metodologia específica necessária",
      title: "Esta versão cobre pessoas de 18 a 64 anos",
      body: "A partir de 65 anos, estado nutricional, atividade, doenças e tolerância precisam de um fluxo próprio antes de apresentar uma estimativa.",
      returnStep: 1,
    },
    competitive: {
      eyebrow: "Fora do escopo desta versão beta",
      title: "Atletas competitivos exigem avaliação própria",
      body: "Volume de treino, fase competitiva, energia disponível e composição corporal não são capturados por esta calculadora geral.",
      returnStep: 1,
    },
    clinical: {
      eyebrow: "Orientação individual recomendada",
      title: "Uma calculadora geral não é adequada para este caso",
      body: "A quantidade de proteína pode precisar considerar exames, tratamento, tolerância, fase de vida ou estado nutricional. Procure um profissional habilitado.",
      returnStep: 2,
    },
    lowBmi: {
      eyebrow: "Orientação individual recomendada",
      title: "Seu peso e sua altura deixam o caso fora do fluxo geral",
      body: "Isso não é um diagnóstico. Uma avaliação individual é mais adequada antes de definir uma meta em gramas.",
      returnStep: 3,
    },
    bmiOutsideBeta: {
      eyebrow: "Metodologia específica necessária",
      title: "Esta versão beta não calculará este perfil",
      body: "Para evitar usar uma fórmula de ajuste de peso que ainda não foi validada para esta ferramenta, a estimativa é interrompida. Isso não significa que proteína seja contraindicada.",
      returnStep: 3,
    },
    weightMedication: {
      eyebrow: "Orientação individual recomendada",
      title: "O contexto do medicamento exige uma avaliação própria",
      body: "Medicamentos que alteram apetite e ingestão podem exigir acompanhamento nutricional individual. Esta versão não usa o medicamento para aumentar ou reduzir um coeficiente.",
      returnStep: 3,
    },
    leanWeightLoss: {
      eyebrow: "Regra ainda não definida",
      title: "Esta versão não estimará este objetivo sem exercício",
      body: "Para perda de peso sem exercício estruturado e IMC abaixo de 25, a metodologia atual não possui uma regra suficientemente definida.",
      returnStep: 3,
    },
    pending: {
      eyebrow: "Metodologia incompleta",
      title: "Este perfil ainda não possui regra nesta versão",
      body: "A calculadora interrompeu o fluxo para não apresentar um número baseado em uma suposição não documentada.",
      returnStep: 3,
    },
    invalid: {
      eyebrow: "Revise as informações",
      title: "Não foi possível calcular",
      body: "Confira os valores e as unidades informadas antes de tentar novamente.",
      returnStep: 3,
    },
    trainingMismatch: {
      eyebrow: "Revise seu treino",
      title: "A frequência e o tipo de treino não combinam",
      body: "Se você não treina, selecione “não pratico exercício estruturado”. Se treina, escolha o tipo predominante.",
      returnStep: 3,
    },
  };

  function formatDecimal(value, digits) {
    return Number(value).toFixed(digits).replace(".", ",");
  }

  function checkedValue(root, name) {
    var input = root.querySelector('input[name="' + name + '"]:checked');
    return input ? input.value : "";
  }

  function fieldValue(root, field) {
    var input = root.querySelector('[data-spc-field="' + field + '"]');
    return input ? input.value : "";
  }

  function setError(root, field, message) {
    var error = root.querySelector('[data-spc-error-for="' + field + '"]');
    var controls = root.querySelectorAll(
      '[data-spc-field="' + field + '"], input[name="' + field + '"]',
    );

    if (error) {
      error.textContent = message || "";
      error.hidden = !message;
    }

    controls.forEach(function setInvalid(control) {
      if (message) {
        control.setAttribute("aria-invalid", "true");
      } else {
        control.removeAttribute("aria-invalid");
      }
    });
  }

  function clearErrors(root) {
    root.querySelectorAll("[data-spc-error-for]").forEach(function clear(error) {
      error.textContent = "";
      error.hidden = true;
    });
    root.querySelectorAll('[aria-invalid="true"]').forEach(function reset(control) {
      control.removeAttribute("aria-invalid");
    });
  }

  function initCalculator(root) {
    var currentStep = 1;
    var returnStepAfterStop = 1;
    var panels = Array.from(root.querySelectorAll("[data-spc-step]"));
    var progressBar = root.querySelector("[data-spc-progress-bar]");
    var progressCurrent = root.querySelector("[data-spc-progress-current]");
    var progressLabel = root.querySelector("[data-spc-progress-label]");
    var methodPanel = root.querySelector("[data-spc-method-panel]");
    var methodToggle = root.querySelector("[data-spc-method-toggle]");
    var stepLabels = ["Escopo", "Segurança", "Seu perfil", "Resultado"];

    function showStep(step) {
      currentStep = step;
      clearErrors(root);

      panels.forEach(function togglePanel(panel) {
        panel.hidden = Number(panel.getAttribute("data-spc-step")) !== step;
      });

      if (progressBar) progressBar.style.width = String(step * 25) + "%";
      if (progressCurrent) progressCurrent.textContent = String(step);
      if (progressLabel) progressLabel.textContent = stepLabels[step - 1];

      var heading = root.querySelector(
        '[data-spc-step="' + step + '"] [data-spc-panel-title]',
      );
      if (heading) {
        window.requestAnimationFrame(function focusHeading() {
          heading.focus({ preventScroll: true });
          heading.scrollIntoView({ behavior: "smooth", block: "center" });
        });
      }
    }

    function showStop(result) {
      var copy = STOP_COPY[result.messageKey] || STOP_COPY.pending;
      var eligible = root.querySelector("[data-spc-result-eligible]");
      var stopped = root.querySelector("[data-spc-result-stopped]");

      returnStepAfterStop = copy.returnStep;
      if (eligible) eligible.hidden = true;
      if (stopped) stopped.hidden = false;

      root.querySelector("[data-spc-stop-eyebrow]").textContent = copy.eyebrow;
      root.querySelector("[data-spc-stop-title]").textContent = copy.title;
      root.querySelector("[data-spc-stop-body]").textContent = copy.body;
      showStep(4);
    }

    function showEligible(result) {
      var eligible = root.querySelector("[data-spc-result-eligible]");
      var stopped = root.querySelector("[data-spc-result-stopped]");
      var mainValue = root.querySelector("[data-spc-main-value]");
      var mainUnit = root.querySelector("[data-spc-main-unit]");
      var referenceStrip = root.querySelector("[data-spc-reference-strip]");
      var resultBadge = root.querySelector("[data-spc-applicability]");
      var rangeLow = root.querySelector("[data-spc-range-low]");
      var rangeHigh = root.querySelector("[data-spc-range-high]");
      var rangePoint = root.querySelector("[data-spc-range-point]");
      var rangePointWrap = root.querySelector("[data-spc-range-point-wrap]");
      var referenceRawRow = root.querySelector("[data-spc-reference-raw-row]");
      var referenceRaw = root.querySelector("[data-spc-reference-raw]");
      var calcResult = root.querySelector("[data-spc-calc-result]");

      if (stopped) stopped.hidden = true;
      if (eligible) eligible.hidden = false;

      resultBadge.textContent =
        result.applicability === "DIRECT"
          ? "Referência mais direta para o perfil"
          : "Orientação aproximada";
      resultBadge.setAttribute(
        "data-state",
        result.applicability === "DIRECT" ? "direct" : "approximate",
      );

      if (result.isSingleReference) {
        mainValue.textContent = "≈ " + result.displayReferenceG;
        mainUnit.textContent = "g por dia";
        referenceStrip.hidden = true;
        rangeLow.textContent = String(result.displayReferenceG) + " g";
        rangeHigh.textContent = String(result.displayReferenceG) + " g";
        rangePointWrap.hidden = true;
      } else {
        mainValue.textContent =
          String(result.displayLowerG) + "–" + String(result.displayUpperG);
        mainUnit.textContent = "g por dia";
        rangeLow.textContent = String(result.displayLowerG) + " g";
        rangeHigh.textContent = String(result.displayUpperG) + " g";

        if (result.displayReferenceG !== null) {
          referenceStrip.hidden = false;
          referenceStrip.querySelector("strong").textContent =
            "≈ " + String(result.displayReferenceG) + " g/dia";
          rangePointWrap.hidden = false;
          rangePoint.textContent = "≈ " + String(result.displayReferenceG) + " g";
        } else {
          referenceStrip.hidden = true;
          rangePointWrap.hidden = true;
        }
      }

      root.querySelector("[data-spc-profile]").textContent = result.profileLabel;
      root.querySelector("[data-spc-bmi]").textContent =
        formatDecimal(result.bmiDisplay, 1);

      var coefficientText = result.isSingleReference
        ? formatDecimal(result.referenceCoefficient, 2) + " g/kg/dia"
        : formatDecimal(result.coefficientLower, 1) +
          "–" +
          formatDecimal(result.coefficientUpper, 1) +
          " g/kg/dia";
      root.querySelectorAll("[data-spc-coefficient]").forEach(function setCoefficient(node) {
        node.textContent = coefficientText;
      });
      root.querySelectorAll("[data-spc-weight]").forEach(function setWeight(node) {
        node.textContent =
          formatDecimal(result.weightForCalculationKg, 1) + " kg";
      });

      if (result.gramsReferenceRaw !== null) {
        referenceRawRow.hidden = false;
        referenceRaw.textContent =
          formatDecimal(result.gramsReferenceRaw, 1) + " g";
      } else {
        referenceRawRow.hidden = true;
      }

      calcResult.textContent =
        result.displayReferenceG !== null
          ? "≈ " + String(result.displayReferenceG) + " g/dia"
          : String(result.displayLowerG) +
            "–" +
            String(result.displayUpperG) +
            " g/dia";

      var goalNote = root.querySelector("[data-spc-goal-note]");
      goalNote.hidden = !result.flags.includes(
        "GOAL_NOT_MATCHED_BY_RESISTANCE_TRAINING",
      );

      if (methodPanel) methodPanel.hidden = true;
      if (methodToggle) {
        methodToggle.setAttribute("aria-expanded", "false");
        methodToggle.querySelector("[data-spc-method-symbol]").textContent = "+";
      }

      showStep(4);
    }

    function validateScope() {
      var age = engine.parseLocaleNumber(fieldValue(root, "age"), {
        integer: true,
      });
      var professionalPlan = checkedValue(root, "professionalPlan");
      var pregnancy = checkedValue(root, "pregnancy");
      var bariatric = checkedValue(root, "bariatric");
      var competitive = checkedValue(root, "competitive");
      var invalid = false;

      clearErrors(root);

      if (age === null || age < 0 || age > 120) {
        setError(root, "age", "Informe a idade em anos completos, entre 0 e 120.");
        invalid = true;
      }
      [
        ["professionalPlan", professionalPlan],
        ["pregnancy", pregnancy],
        ["bariatric", bariatric],
        ["competitive", competitive],
      ].forEach(function requireChoice(pair) {
        if (!pair[1]) {
          setError(root, pair[0], "Selecione uma opção.");
          invalid = true;
        }
      });

      if (invalid) return;

      if (age < 18) return showStop({ messageKey: "underage" });
      if (professionalPlan === "yes") {
        return showStop({ messageKey: "professional" });
      }
      if (pregnancy === "yes" || bariatric === "yes") {
        return showStop({ messageKey: "scope" });
      }
      if (competitive === "yes") {
        return showStop({ messageKey: "competitive" });
      }
      if (age >= 65) return showStop({ messageKey: "olderAdult" });

      showStep(2);
    }

    function validateSafety() {
      var none = root.querySelector('[data-spc-field="clinicalNone"]');
      var flags = root.querySelectorAll('[data-spc-field="clinicalFlag"]:checked');
      var unintendedLoss = checkedValue(root, "unintendedLoss");
      var reducedIntake = checkedValue(root, "reducedIntake");
      var malnutrition = checkedValue(root, "malnutrition");
      var invalid = false;

      clearErrors(root);

      if ((!none || !none.checked) && flags.length === 0) {
        setError(
          root,
          "clinicalChoice",
          "Marque ao menos uma situação ou selecione “nenhuma”.",
        );
        invalid = true;
      }
      [
        ["unintendedLoss", unintendedLoss],
        ["reducedIntake", reducedIntake],
        ["malnutrition", malnutrition],
      ].forEach(function requireChoice(pair) {
        if (!pair[1]) {
          setError(root, pair[0], "Selecione uma opção.");
          invalid = true;
        }
      });

      if (invalid) return;

      if (
        flags.length > 0 ||
        unintendedLoss === "yes" ||
        reducedIntake === "yes" ||
        malnutrition === "yes"
      ) {
        return showStop({ messageKey: "clinical" });
      }

      showStep(3);
    }

    function calculate() {
      var age = engine.parseLocaleNumber(fieldValue(root, "age"), {
        integer: true,
      });
      var weight = engine.parseLocaleNumber(fieldValue(root, "weight"));
      var height = engine.parseLocaleNumber(fieldValue(root, "height"));
      var days = engine.parseLocaleNumber(fieldValue(root, "trainingDays"), {
        integer: true,
      });
      var goal = checkedValue(root, "goal");
      var medication = checkedValue(root, "medication");
      var trainingType = checkedValue(root, "trainingType");
      var invalid = false;

      clearErrors(root);

      if (weight === null || weight < 25 || weight > 500) {
        setError(root, "weight", "Informe o peso em kg, entre 25 e 500.");
        invalid = true;
      }
      if (height === null || height < 100 || height > 250) {
        setError(root, "height", "Informe a altura em cm, entre 100 e 250.");
        invalid = true;
      }
      if (!goal) {
        setError(root, "goal", "Selecione seu objetivo.");
        invalid = true;
      }
      if (!medication) {
        setError(root, "medication", "Selecione uma opção.");
        invalid = true;
      }
      if (days === null || days < 0 || days > 7) {
        setError(root, "trainingDays", "Informe um número inteiro de 0 a 7.");
        invalid = true;
      }
      if (days !== null && days > 0 && !trainingType) {
        setError(root, "trainingType", "Escolha o tipo predominante de treino.");
        invalid = true;
      }

      if (invalid) return;

      var result = engine.calculateProtein({
        ageYears: age,
        weightKg: weight,
        heightCm: height,
        goal: goal,
        trainingDaysWeek: days,
        trainingType: days === 0 ? "none" : trainingType,
        trainingIsCompetitive: false,
        clinicalRoute: "ELIGIBLE_STANDARD",
        usesWeightMedication: medication,
      });

      if (result.status === "ELIGIBLE_STANDARD") {
        showEligible(result);
      } else {
        showStop(result);
      }
    }

    function restart() {
      root
        .querySelectorAll("[data-spc-step] input")
        .forEach(function resetInput(input) {
        if (input.type === "radio" || input.type === "checkbox") {
          input.checked = false;
        } else {
          input.value = "";
        }
        });
      root
        .querySelectorAll("[data-spc-choice].is-selected")
        .forEach(function clearSelected(choice) {
          choice.classList.remove("is-selected");
        });
      var trainingTypeGroup = root.querySelector("[data-spc-training-type-group]");
      if (trainingTypeGroup) trainingTypeGroup.hidden = true;
      showStep(1);
    }

    function syncTrainingTypeVisibility(value) {
      var parsedDays = engine.parseLocaleNumber(value, { integer: true });
      var group = root.querySelector("[data-spc-training-type-group]");
      if (group) group.hidden = parsedDays === 0 || parsedDays === null;
      if (parsedDays === 0) {
        root
          .querySelectorAll('input[name="trainingType"]')
          .forEach(function clearTrainingType(input) {
            input.checked = false;
            var label = input.closest("[data-spc-choice]");
            if (label) label.classList.remove("is-selected");
          });
      }
    }

    root.addEventListener("change", function handleChange(event) {
      var target = event.target;
      if (!(target instanceof HTMLInputElement)) return;

      if (target.type === "radio") {
        if (target.name) setError(root, target.name, "");
        root
          .querySelectorAll('input[name="' + target.name + '"]')
          .forEach(function syncRadio(input) {
            var label = input.closest("[data-spc-choice]");
            if (label) label.classList.toggle("is-selected", input.checked);
          });
      }

      if (target.matches('[data-spc-field="clinicalNone"]') && target.checked) {
        root
          .querySelectorAll('[data-spc-field="clinicalFlag"]')
          .forEach(function clearFlag(flag) {
            flag.checked = false;
            var label = flag.closest("[data-spc-choice]");
            if (label) label.classList.remove("is-selected");
          });
      }

      if (target.matches('[data-spc-field="clinicalFlag"]')) {
        var none = root.querySelector('[data-spc-field="clinicalNone"]');
        if (none) {
          none.checked = false;
          var noneLabel = none.closest("[data-spc-choice]");
          if (noneLabel) noneLabel.classList.remove("is-selected");
        }
        var flagLabel = target.closest("[data-spc-choice]");
        if (flagLabel) flagLabel.classList.toggle("is-selected", target.checked);
      }

      if (target.matches('[data-spc-field="trainingDays"]')) {
        syncTrainingTypeVisibility(target.value);
      }
    });

    root.addEventListener("input", function clearInputError(event) {
      var target = event.target;
      if (!(target instanceof HTMLInputElement)) return;
      var field = target.getAttribute("data-spc-field");
      if (field) setError(root, field, "");
      if (field === "trainingDays") {
        syncTrainingTypeVisibility(target.value);
      }
    });

    root.addEventListener("click", function handleClick(event) {
      var button = event.target.closest("[data-spc-action]");
      if (!button) return;

      var action = button.getAttribute("data-spc-action");
      if (action === "scope-next") validateScope();
      if (action === "safety-next") validateSafety();
      if (action === "calculate") calculate();
      if (action === "back") showStep(Math.max(1, currentStep - 1));
      if (action === "restart") restart();
      if (action === "adjust-profile") showStep(3);
      if (action === "review-stop") showStep(returnStepAfterStop);

      if (action === "toggle-method" && methodPanel && methodToggle) {
        var willOpen = methodPanel.hidden;
        methodPanel.hidden = !willOpen;
        methodToggle.setAttribute("aria-expanded", String(willOpen));
        methodToggle.querySelector("[data-spc-method-symbol]").textContent =
          willOpen ? "−" : "+";
      }
    });

    showStep(1);
  }

  function initAll() {
    document.querySelectorAll("[data-spc-root]").forEach(initCalculator);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAll, { once: true });
  } else {
    initAll();
  }
})();
